import RobotPositionSetupPage from '@/pages/robots/RobotPositionSetup'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_private/robots/$id/position')({
  component: RobotPositionSetupPage,
})
